<template>
  <div class="page">
    <excel v-if="dialogTableVisible" @errortbn="dialogTableVisible = false;submitForm()"></excel>
    <template v-else>
      <el-form :inline="true" ref="form" style="display: flex;" label-width="100px">
        <el-input type="textarea" :rows="4" placeholder="请输入运单号或转单号，多个用逗号隔开" v-model="waybillNos" @keyup.enter.native="submitForm" style="width: 300px;margin-right: 18px;margin-bottom: 18px;"></el-input>
        <div style="flex: 1;">
          <el-form-item label="预报时间">
            <el-date-picker v-model="datetimerange[0]" type="date" value-format='yyyy-MM-dd HH:mm:ss' placeholder="开始日期">
            </el-date-picker>
            <label style="margin: 15px;">至</label>
            <el-date-picker v-model="datetimerange[1]" type="date" value-format='yyyy-MM-dd HH:mm:ss' placeholder="结束日期">
            </el-date-picker>
          </el-form-item>
          <br />
          <el-form-item label="服务商">
            <el-select v-model="spId" filterable placeholder="请选择服务商">
              <el-option v-for="(item,i) in branchlist" :key="i" :label="item.branchName" :value="item.branchCode">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="目的地" placeholder="请选择目的地" clearable>
            <el-select v-model="countryCode" clearable filterable default-first-option remote :remote-method="filterCountry" placeholder="请选择目的地">
              <el-option :value="country.countryCode" :label="country.nameChinese" v-for="(country,i) in countryOptionsCrror" :key="i">{{country.countryCode}}<el-divider direction="vertical"></el-divider>{{country.nameChinese}}<el-divider direction="vertical"></el-divider>{{country.nameEnglish}}</el-option>
            </el-select>
          </el-form-item>
        </div>
      </el-form>
      <div style="margin-bottom: 18px;">
        <el-button type="primary" icon="el-icon-plus" @click="addcrr">单票录入</el-button>
        <el-button type="primary" icon="el-icon-s-data" @click="()=>dialogTableVisible = true">EXCEL导入</el-button>
        <el-button icon="el-icon-edit" @click="updcrr">修改</el-button>
        <el-button icon='el-icon-delete-solid' @click="facilitatorReturn">删除</el-button>
        <el-button icon="el-icon-lock" @click="withhold">申请暂扣</el-button>
        <el-button icon="el-icon-unlock" @click="unwithhold">取消暂扣</el-button>
        <el-button icon="el-icon-tickets" @click="downloadLabel">下载标签</el-button>		
        <el-button icon="el-icon-document" @click="downloadInvoice">下载发票</el-button>			
        <el-button type="primary" icon="el-icon-search" @click="submitForm" style="margin-left: 90px;">查询</el-button>
        <el-button icon="el-icon-refresh" @click="resetForm">重置</el-button>
        <el-button icon="el-icon-download" @click="handleDownload">导出</el-button>
      </div>
      <el-table-auto :ref="ref" id='delivery' name='预报' :column='tableConf' :table-hand='getTable' :down-hand='paraphrase' @cell-dblclick='cellclickwayBillNo' @selection-change="handleSelectionChange" style="flex: 1;display: flex;flex-direction: column;overflow: hidden;">
        <template #scanUser="{row}">
          {{row.scanUser?crruser(row.scanUser).userName:''}}
        </template>
        <template #wayBillNo="{row}">
			<el-badge v-if="row.forcastStatus == 2" value="暂扣" style='position: absolute;top: 14px;'>
				<span @click="cellclickwayBillNo(row)" class="blue">{{row.wayBillNo}}</span>
			</el-badge>
          	<span v-else @click="cellclickwayBillNo(row)" class="blue">{{row.wayBillNo}}</span>
        </template>
        <template #goodsType="{row}">
          {{getGoodsTypeName(row.goodsType)}}
        </template>
        <template #battery="{row}">
          {{row.battery === 0?'无电': row.battery ===  1?'内电':row.battery=== 2? '外电':'纯电'}}
        </template>
        <template #gateDeclared="{row}">
          {{row.gateDeclared == 1?'报关':'不报关'}}
        </template>
        <template #freight="{row}">
          {{row.freight + row.inFreightConditionAdd}}
        </template>
      </el-table-auto>
	  <forecast ref="forecastDrawer" :quoteList="quotelist" :countryOptions="countryOptions" :branchList="branchlist" @submit="submitForm"></forecast>
      <template v-if="false">
        <el-divider></el-divider>
        <div style="background-color: #bedafb;padding: 12px 5px;">
          <label style="margin-right: 18px;color: orangered;">服务商</label>
          <el-select v-model="form.branchCode" filterable placeholder="请选择服务商" class="yellow-input" style="margin-right: 18px;">
            <el-option v-for="(item,i) in branchlist" :key="i" :label="item.branchName" :value="item.branchCode">
            </el-option>
          </el-select>
          <el-button-group>
            <el-button :loading='uploaditeming' type="primary" icon="el-icon-upload" style="background-color: green;" @click="uploaditem" ref='upcom' class="updatarow" @keyup.enter='uploaditem'>上传</el-button>
            <el-button @click="$refs['formitem'].resetFields()">重置</el-button>
            <el-button icon="el-icon-s-release" @click="()=>showopne=false" style="background-color: orange;color: white;">关闭</el-button>
          </el-button-group>
        </div>
        <div style="background-color:#DAE8F0;overflow: auto;position: relative;">
			<div v-if="!form.branchCode" style="position: absolute;top: 0;left: 0;width: 100%;height: 100%;background-color: #08080868;z-index: 100;"></div>
          <el-form :model="form" :rules="rules" :inline="true" ref="formitem" label-width="70px" style="width: 1350px;margin: 18px 0;">
            <el-form-item label="单号" prop="wayBillNo" ref="wayBillNo" class="medium-form-item">
              <el-input v-model="form.wayBillNo" autocomplete="off" placeholder="请选择单号" clearable @keyup.enter.native='keyupEnter("wayBillNo")'></el-input>
            </el-form-item>
            <el-form-item label="渠道" prop="quoteCode" ref="quoteCode" class="medium-form-item">
              <el-select v-model="form.quoteCode" filterable :disabled="!form.branchCode" placeholder="请选择渠道" clearable @keyup.enter.native='keyupEnter("quoteCode")'>
                <el-option v-for="(item,index) in crrquotelist" :key="index" :label="item.providerQuoteName" :value="item.providerQuoteCode">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="目的地" prop="destination" ref="destination" class="medium-form-item">
              <el-select v-model="form.destination" filterable default-first-option remote :remote-method="filterCountry" @change="changeCountry" clearable placeholder="请选择目的地" @keyup.enter.native='keyupEnter("destination")'>
                <el-option :value="country.countryCode" :label="country.nameChinese" v-for="(country,i) in countryOptionsCrror" :key="i">{{country.countryCode}}<el-divider direction="vertical"></el-divider>{{country.nameChinese}}<el-divider direction="vertical"></el-divider>{{country.nameEnglish}}</el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="件数" prop="pieces" ref="pieces" class="ss-form-item">
              <el-input v-model="form.pieces" maxlength="4" onkeypress="return (/[\d\.]/.test(String.fromCharCode(event.keyCode)))" @keyup.enter.native='keyupEnter("pieces")'></el-input>
            </el-form-item>
            <el-form-item label="重量" prop="settlementWeight" ref="settlementWeight" class="short-form-item">
              <el-input v-model="form.settlementWeight" onkeypress="return (/[\d\.]/.test(String.fromCharCode(event.keyCode)))" @keyup.enter.native='keyupEnter("settlementWeight")'></el-input>
            </el-form-item>
            <el-form-item label="邮编" prop="postCode" ref="postCode" class="medium-form-item">
              <el-select v-model="form.postCode" :disabled="!form.destination" filterable default-first-option remote :remote-method="remoteMethodPostCode" @change="changePostCodeCityName(countrycityOptions,$event)" clearable :placeholder="!form.countryCode?'目的地未选择':'请选择邮编'" @keyup.enter.native='keyupEnter("postCode")'>
                <el-option :label="countrycity.cityInfo" :value="i" v-for="(countrycity,i) in countrycityOptions" :key="i"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="城市" prop="cityName" ref="cityName" class="medium-form-item">
              <el-select v-model="form.cityName" :disabled="!form.destination" filterable default-first-option remote :remote-method="remoteMethodCityName" @change="changePostCodeCityName(countrycityOptions,$event)" clearable :placeholder="!form.countryCode?'目的地未选择':'请选择城市'" @keyup.enter.native='keyupEnter("cityName")'>
                <el-option :label="countrycity.cityInfo" :value="i" v-for="(countrycity,i) in countrycityOptions" :key="i"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="申报价值" prop="valueDeclared" ref="valueDeclared" class="medium-form-item">
              <el-input v-model.number="form.valueDeclared" type='number' autocomplete="off" @keyup.enter.native='keyupEnter("valueDeclared")'></el-input>
            </el-form-item>
            <el-form-item prop="battery" ref="battery" class="short-form-item" style="margin-left: 20px;">
              <el-select v-model="form.battery" filterable default-first-option remote @keyup.enter.native='keyupEnter("battery")'>
                <el-option :label="battery.value" :value="parseInt(battery.key)" v-for="(battery,i) in batteryList" :key="i"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="goodsType" ref="goodsType" class="short-form-item" style="margin-left: 20px;">
              <el-select v-model="form.goodsType" filterable default-first-option remote @keyup.enter.native='keyupEnter("goodsType")'>
                <el-option :label="goodsType.value" :value="parseInt(goodsType.key)" v-for="(goodsType,i) in goodsTypeList" :key="i"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="gateDeclared" ref="gateDeclared" class="short-form-item" style="margin-left: 20px;">
              <el-select v-model="form.gateDeclared" filterable default-first-option remote @keyup.enter.native='keyupEnter("gateDeclared")'>
                <el-option label="不报关" :value="0"></el-option>
                <el-option label="报关" :value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="remark" label="备注" ref="remark">
              <el-input placeholder="备注信息" v-model="form.remark" autocomplete="off" @keyup.enter.native='onkeydown("remark","upcom","button")'></el-input>
            </el-form-item>
            <el-form-item v-if="calcFreight">
              <div>【运费：{{calcFreight.freight}} 附加费：{{calcFreight.freightAdd}}】
                <span v-if="calcFreight.addFeeObjListval" style="color: red;">问题：{{calcFreight.addFeeObjListval}}</span>
                <span v-if="calcFreight.tipsListval" style="color: orange;">【提示：{{calcFreight.tipsListval}}】</span>
                <!-- <template v-if="calcFreight.extraInfo"><span style="color: orange;">【{{calcFreight.extraInfo}}】</span></template> -->
              </div>
            </el-form-item>
          </el-form>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import { page } from '@/mixins/page'
import * as string from '@/utils/string'
import * as msg from '@/utils/msg'
import excel from './excel'
import forecast from './forecast'
import axios from 'axios'
export default {
	mixins: [page],
	components: {
		excel,
		forecast
	},
	data() {
		return {
			ref: 'delivery',
			// form
			countryOptions: [],
			countryOptionsCrror: [],
			quotelist: [],
			biztypelist: [],
			countrycityOptions: [],
			countryCode: '',
			// table
			tableConf: [
				{ template: 'scanUser', label: '操作人', width: 80 },
				{ prop: 'operationUpdateTime', label: '预报时间', width: 160 },
				{ prop: 'branchName', label: '服务商', width: 90 },
				{ template: 'wayBillNo', label: '原单号', width: 120 },
				{ prop: 'quoteName', label: '渠道名', width: 180 },
				{ prop: 'destinationName', label: '目的地', width: 110 },
				{ prop: 'pieces', label: '件数', width: 60 },
				{ prop: 'settlementWeight', label: '结算重', width: 100 },
				{ template: 'goodsType', label: '货物类型', width: 80 },
				{ template: 'battery', label: '电池', width: 100 },
				{ template: 'gateDeclared', label: '报关', width: '110' },
				{ prop: 'valueDeclared', label: '申报价值', width: 100 },
				{ prop: 'freight', label: '运费', width: 100 },
				{ prop: 'inFreightConditionAdd', label: '附加费', width: 100 },
				{ template: 'freight', label: '总费用', width: 100 },
				{ prop: 'hintMessage', label: '系统提示', width: 160 },
				{ prop: 'warning', label: '计费问题', width: 160 },
				{ prop: 'remark', label: '备注', width: 160 },
				{ prop: 'realWeight', label: '实重', width: 120 },
				{ prop: 'materialWeight', label: '体积重', width: 120 },
			],
			multipleSelection: [],
			// 添加
			showopne: false,
			form: {
				branchCode: '',
				wayBillNo: '',
				quoteCode: '',
				destination: '',
				pieces: '',
				settlementWeight: '',
				postCode: '',
				cityName: '',
				valueDeclared: '',
				battery: 0,
				goodsType: 1,
				gateDeclared: 0,
				remark: '',
				remoted: false,
			},
			backupsform: '',
			rules: {
				wayBillNo: [{ required: true, message: '不能为空', trigger: 'change' }],
				quoteCode: [{ required: true, message: '不能为空', trigger: 'change' }],
				destination: [{ required: true, message: '不能为空', trigger: 'change' }],
				pieces: [{ required: true, message: '不能为空', trigger: 'change' }],
				settlementWeight: [{ required: true, message: '不能为空', trigger: 'change' }],
			},
			calcFreight: '',
			uploaditeming: false,
			dialogTableVisible: false,
		}
	},
	computed: {
		crrquotelist() {
			if (!this.form.branchCode) return []
			let list = []
			this.quotelist
				.filter((ele) => ele.providerCode == this.form.branchCode)
				.map((item) => {
					list.push({ providerQuoteCode: item.providerQuoteCode || item.quoteCode, providerQuoteName: item.providerQuoteName, bizType: item.bizType })
				})
			return list
		},
		// 算费
		freightchang() {
			const { branchCode, quoteCode, destination, pieces, settlementWeight, postCode, valueDeclared, battery, goodsType, gateDeclared } = this.form
			return { branchCode, quoteCode, destination, pieces, settlementWeight, postCode, valueDeclared, battery, goodsType, gateDeclared }
		},
	},
	watch: {
		'form.branchCode'() {
			this.form.quoteCode = ''
		},
		// 算费
		freightchang: {
			handler() {
				this.calcFreight = ''
				if (!this.form.branchCode) return
				if (!this.form.quoteCode) return
				if (!this.form.destination) return
				if (!this.form.pieces) return
				if (!this.form.settlementWeight) return
				//this.getputStoragescan()
			},
		},
	},
	mounted() {
		this.getCountrylist()
		this.getquotelist()
		this.getbiztype()
		this.backupsform = { ...this.form } // 拷贝一个初始数据
		this.form.branchCode = this.spId
		this.activety()
	},
	activated() {
		this.activety()
	},
	methods: {
		// 重置表格
		getReset() {
			this.countryCode = ''
		},
		// 表格查询
		async getTable(pages) {
			let params = { ...pages, scanStatus: '1,2', operatingStatus: '2', asPrint: '1', providerOperatingStatus: '1' }
			if (this.waybillNos) params.waybillNos = this.waybillNos
			if (this.spId) params.spId = this.spId
			if (this.datetimerange) {
				params.startDate = this.datetimerange[0].substring(0, 10) + ' 00:00:00'
				params.endDate = this.datetimerange[1].substring(0, 10) + ' 23:59:59'
				if (params.startDate > params.endDate) {
					this.$message.warning('运单开始时间不能大于结束数据')
					return { list: [], total: 0 }
				}
			}
			this.waybillNos = this.waybillNos.trim().replaceAll('\n', ',')
			if (this.waybillNos) {
				params = { ...pages, operatingStatus: '2' }
				params.waybillNos = this.waybillNos
			}
			return await this.$api.getscanlist(params)
		},
		// 导出字段转义
		paraphrase(row, template) {
			if (template == 'spId') {
				return this.crrbranch(row.spId).branchName
			}
			if (template == 'operatingStatus') {
				return (this.operatingStatusList.find((item) => row.operatingStatus == item.key) || {}).value
			}
			if (template == 'serviceStatus') {
				return this.numtotitflog(row.serviceStatus, 0) ? '港前问题' : this.numtotitflog(row.serviceStatus, 1) ? '港后问题' : this.numtotitflog(row.serviceStatus, 4) ? '收货问题' : this.numtotitflog(row.serviceStatus, 5) ? '欠费问题' : this.numtotitflog(row.serviceStatus, 3) ? '待退走' : ''
			}
			if (template == 'serviceInfo') {
				if (row.serviceInfo) {
					return row.serviceInfo + (row.serviceInfoTime?row.serviceInfoTime.substring(5, 16):'') + (row.serviceInfoToPerson?row.serviceInfoToPerson:'')
				}
			}
			if (template == 'trackInfo') {
				if (row.publicTrackTime && row.trackTime) {
					if (row.publicTrackTime > row.trackTime) {
						return '【' + row.publicTrackTime + row.trackPlace + '】' + row.publicTrackInfo
					} else {
						return row.trackInfo
					}
				} else if (row.publicTrackTime) {
					return '【' + row.publicTrackTime + row.trackPlace + '】' + row.publicTrackInfo
				} else {
					return row.trackInfo
				}
			}
			if (template == 'battery') {
				return row.battery === '0' ? '无电' : row.battery === '1' ? '内电' : row.battery === '2' ? '外电' : '纯电'
			}
			if (template == 'gateDeclared') {
				return row.gateDeclared === '1' ? '报关' : '不报关'
			}
		},
		// 多选
		handleSelectionChange(val) {
			this.multipleSelection = val
		},
		// ----------------------------------
		// 路由处理，查价过来
		activety() {
			if (this.$route.params.option && this.$route.params.form) {
				let row = this.$route.params.option				
				let form = this.$route.params.form
				let voucher = {
					wayBillNo: "",
					providerCode: row.providerCode,
					quoteCode: row.providerQuoteCode,
					pieces: 1,
					settlementWeight: row.weight,
					receiverCountryCode: form.countryCode,
					receiverPostCode: form.postCode,
					receiverCityName: form.cityName,
					totalPrice: form.valueDeclared,
					goodsType: form.goodsType == 2? 2:1,
					gateDeclared: form.canDeclare == 1?'单独报关':'不报关'
				}
				voucher.batteryName = '无电'
				if(form.canBatteryInside == 1){
					voucher.batteryName = 'PI967多电'
				}else
				if(form.canBatteryWith == 1){
					voucher.batteryName = 'PI966'
				}else
				if(form.canBatteryAll == 1){
					voucher.batteryName = 'PI965'
				}
				this.$refs.forecastDrawer.open(voucher)
				return
				this.form.branchCode = row.providerCode
				this.form.quoteCode = row.providerQuoteCode
				this.form.destination = this.$route.params.form.countryCode
				this.form.pieces = 1
				this.form.settlementWeight = row.weight
				this.form.postCode = this.$route.params.form.postCode
				this.form.cityName = this.$route.params.form.cityName
				this.form.valueDeclared = this.$route.params.form.valueDeclared
				if (this.$route.params.form.canBatteryInside + this.$route.params.form.canBatteryWith + this.$route.params.form.canBatteryAll == 1) {
					this.form.battery = this.$route.params.form.canBatteryInside ? 1 : this.$route.params.form.canBatteryWith ? 2 : this.$route.params.form.canBatteryAll ? 3 : 0
				} else {
					this.form.battery = 0 // 有默认值
				}
				this.form.goodsType = this.$route.params.form.goodsType == 2 ? 2 : 1 // 有默认值
				this.form.gateDeclared = this.$route.params.form.canDeclare // 有默认值
				this.form = { ...this.form }
			}
		},
		// 渠道
		async getquotelist() {
			this.quotelist = await this.$api.getquotelist()
		},
		// 业务类型树
		async getbiztype() {
			this.biztypelist = await this.$api.biztype()
		},
		// 国家
		async getCountrylist() {
			this.countryOptions = await this.$api.countrylist()
			this.filterCountry()
		},
		// 国家过滤
		async filterCountry(country) {
			if (country) {
				let countryOptionsCrror = this.countryOptions.filter((options) => {
					// 国家包含二字码(大写),中文,英文(小写),中文首字母(大写),拼音(小写)对比并排序
					return options.countryCode.indexOf(country.toUpperCase()) != -1 || options.nameChinese.indexOf(country) != -1 || options.nameEnglish.toLowerCase().indexOf(country.toLowerCase()) != -1 || options.firstPinYin.indexOf(country.toUpperCase()) != -1 || string.getPinYinFirstCharacter(options.nameChinese).indexOf(country.toLowerCase()) != -1
				})
				countryOptionsCrror.sort((a, b) => {
					let crr_a = a.countryCode == country.toUpperCase() || a.nameChinese == country || a.nameEnglish.toLowerCase() == country.toLowerCase() || a.firstPinYin == country.toUpperCase() || string.getPinYinFirstCharacter(a.nameChinese.toLowerCase()) == country.toLowerCase()
					let crr_b = b.countryCode == country.toUpperCase() || b.nameChinese == country || b.nameEnglish.toLowerCase() == country.toLowerCase() || b.firstPinYin == country.toUpperCase() || string.getPinYinFirstCharacter(b.nameChinese.toLowerCase()) == country.toLowerCase()
					if (crr_a && !crr_b) return -1
					return 1
				})
				this.countryOptionsCrror = countryOptionsCrror
			} else {
				this.countryOptionsCrror = this.countryOptions
			}
		},
		getGoodsTypeName(goodsType) {
			return msg.getGoodsTypeName(goodsType)
		},
		getOperateTypeName(operateType) {
			return msg.getOperateTypeName(operateType)
		},
		// -------------------
		// 添加
		addcrr() {
			this.form = { ...this.backupsform }
			this.form.wayBillNo = '' //"YB"+parseInt(Math.random()*Math.pow(10,7)) // 单号默认随机9位数
			this.showopne = true
			this.$refs.forecastDrawer.open(this.form.wayBillNo)
		},
		// 修改
		updcrr() {
			if (this.multipleSelection.length != 1) return this.$message.warning('请选中一条数据')
			this.form = { ...this.form, ...this.multipleSelection[0] }
			this.$refs.forecastDrawer.open(this.form.wayBillNo)
		},
		// 邮编
		async remoteMethodPostCode(postCode) {
			if (postCode !== '') {
				this.countrycityOptions = []
				let countrycityOptions = await this.$api.countrycitysearchpage({
					countryCode: this.form.destination,
					postCode,
					pageNum: 1,
					pageSize: 500,
				})
				this.countrycityOptions = countrycityOptions.list
			} else {
				this.countrycityOptions = []
			}
		},
		// 城市
		async remoteMethodCityName(cityName) {
			if (cityName !== '') {
				this.countrycityOptions = []
				let countrycityOptions = await this.$api.countrycitysearchpage({
					countryCode: this.form.destination,
					cityName,
					pageNum: 1,
					pageSize: 500,
				})
				this.countrycityOptions = countrycityOptions.list
			} else {
				this.countrycityOptions = []
			}
		},
		// 被重置邮编和城市
		changeCountry() {
			delete this.form['postCode']
			delete this.form['cityName']
		},
		// 同步邮编城市
		changePostCodeCityName(countrycityOptions, i) {
			if (i === '') {
				return this.changeCountry()
			}
			this.form.postCode = countrycityOptions[i].postCode
			this.form.cityName = countrycityOptions[i].cityName
		},
		// 算费上传格式化
		changequote(val, row) {
			let crr = this.crrquotelist.find((item) => {
				return item.providerQuoteCode == val
			})
			if (crr) {
				row.quoteCode = crr.providerQuoteCode
				row.quoteName = crr.providerQuoteName
			}
		},
		// 算费上传格式化
		changedestination(val, row) {
			let crr = this.countryOptions.find((item) => item.countryCode == val)
			if (crr) {
				row.destination = crr.countryCode
				row.destinationName = crr.nameChinese
			}
		},
		// 算费
		async getputStoragescan() {
			if (this.form.quoteCode) {
				this.changequote(this.form.quoteCode, this.form)
			}
			if (this.form.destination) {
				this.changedestination(this.form.destination, this.form)
			}
			this.form.remoted = false
			// 是否偏远
			if (this.form.postCode && this.form.cityName) {
				// 查询偏远
				let remotearea = await this.$api.remoteareasearch({ countryCode: this.form.destination, startCode: this.form.postCode, endCode: this.form.postCode }) // 偏远
				if (remotearea && remotearea.list && remotearea.list.length) {
					let crrquote = this.crrquotelist.find((crr) => crr.providerQuoteCode == this.form.quoteCode)
					const bizTypeList = await this.$api.getBizTypeEntity({ bizType: crrquote.bizType })
					if (bizTypeList.length) {
						remotearea.list.forEach((element) => {
							if (element.bizGroup == bizTypeList[0].bizGroup) {
								this.form.remoted = true
							}
						})
					}
				}
			}
			let calcFreight = await this.$api.calcFreight(this.form.branchCode, this.form)
			this.calcFreight = {}
			this.calcFreight.freight = calcFreight.scan.freight
			this.calcFreight.freightAdd = calcFreight.scan.freightConditionAdd
			// freightCalcResult未算费信息，errCode>0未错误算费，addFeeObjList/extraInfo为错误条件，errMsg为错误内容;errCode显示addFeeObjList明细项
			if (!calcFreight.freightCalcResult) return
			if (calcFreight.freightCalcResult.errCode) {
				// 先取出总体的错误
				switch (calcFreight.freightCalcResult.errCode) {
					case 10:
						this.calcFreight.addFeeObjListval = '【渠道停用;】'
						break
					case 9:
						this.calcFreight.addFeeObjListval = '【此目的地无价格;】'
						break
					case 8:
						this.calcFreight.addFeeObjListval = '【' + this.form.settlementWeight + 'KG无价格;】'
						break
					case 3:
						this.calcFreight.addFeeObjListval = '【' + calcFreight.freightCalcResult.extraInfo.toString(';') + '】'
						break
					default:
						this.calcFreight.addFeeObjListval = '【无价格;】'
						break
				}
			} else {
				// 加收项错误：addFeeObjList为问题信息， prePortIssues=1&&conditionMatched=true满足问题
				this.calcFreight.addFeeObjListval = calcFreight.freightCalcResult.addFeeObjList.reduce((val, crr) => {
					if (crr.prePortIssues == 1 && crr.conditionMatched == true) {
						val += '[' + crr.ruleRemark + crr.actionDesc + ']'
					}
					return val
				}, '')
			}
			if (this.form.remoted) {
				this.calcFreight.addFeeObjListval += '【偏远！】'
			}
			// 偏远+尺寸备注+非包裹时显示件数
			this.calcFreight = { ...this.calcFreight }
			// 提示
			if (!calcFreight.freightCalcResult.addFeeObjList) return
			// 提示信息：feeType=5为提示信息,conditionMatched==true满足提示
			this.calcFreight.tipsListval = calcFreight.freightCalcResult.addFeeObjList.reduce((val, crr) => {
				if (crr.conditionMatched == true && crr.feeType == 5) {
					val += crr.ruleRemark + crr.actionDesc
				}
				return val
			}, '')
			this.calcFreight = { ...this.calcFreight }
		},
		// 上传
		uploaditem() {
			this.$refs['formitem'].validate(async (valid) => {
				if (!valid) return
				// 运单表存在不能发货
				let params = { pageNum: 1, pageSize: 1, timeType:5, tenantId: localStorage.getItem('tenantId') }
				params.waybillNos = this.form.wayBillNo
				let wa = await this.$api.billAdvanceAccount(params)
				if (wa && wa.list && wa.list.length) return this.$message.warning('此单号服务商已收货，不可预报')
				// 已经预报的做修改操作，否则预报
				this.uploaditeming = true
				let res = await this.$api.putStoragecheck(this.form.wayBillNo)
				if (res) {
					// 运单已存在为修改,添加wayBillId为修改
					this.form.wayBillId = res.wayBillId
				}
				if (this.form.providerQuoteCode) {
					this.changequote(this.form.providerQuoteCode, this.form)
				}
				if (this.form.destination) {
					this.changedestination(this.form.destination, this.form)
				}
				if (this.calcFreight.tipsListval) {
					this.form.hintMessage = this.calcFreight.tipsListval // 提示
				}
				if (this.calcFreight.addFeeObjListval) {
					this.form.warning = this.calcFreight.addFeeObjListval // 问题
				}
				let calcFreight = await this.$api.putStoragescan(this.form.branchCode, this.form)
				this.uploaditeming = false
				if (calcFreight) {
					this.$message.success('发货成功')
					this.$refs['formitem'].resetFields()
					this.submitForm()
					this.$refs['wayBillNo'].focus()
				} else {
					this.$message.warning('发货失败')
				}
			})
		},
		// 删除
		facilitatorReturn() {
			if (!this.multipleSelection.length) return this.$message.warning('请选择数据')
			this.$confirm('此操作将删除数据, 是否继续?', '删除', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			}).then(async () => {
				await this.$api.facilitatorReturn(this.multipleSelection)
				this.submitForm()
			})
		},
		// 暂扣
		async withhold(){
			if (!this.multipleSelection.length) return this.$message.warning('请选择数据')
			let wayBillIds = this.multipleSelection.map(item=>item.wayBillId)
			await this.$api.upservicestatus({wayBillIds,serviceStatus:2})
			this.submitForm()
		},
		// 取消暂扣
		async unwithhold(){
			if (!this.multipleSelection.length) return this.$message.warning('请选择数据')
			let wayBillIds = this.multipleSelection.map(item=>item.wayBillId)
			await this.$api.upservicestatus({wayBillIds,serviceStatus:0})
			this.submitForm()
		},
		// 下载标签
		async downloadLabel(){
			if (this.multipleSelection.length != 1) return this.$message.warning('请选中一条数据')
			this.form = { ...this.form, ...this.multipleSelection[0] }
			console.log(this.form.wayBillNo)
			let data = await this.$api.getLabel(this.form.wayBillNo)
            let url = window.URL.createObjectURL(new Blob([data]))
            let link = document.createElement('a')
            link.style.display = 'none'
            link.href = url
            link.setAttribute('download', this.form.wayBillNo + '运单.pdf')         
            document.body.appendChild(link)
            link.click()
		},
		// 下载发票
		async downloadInvoice(){
			if (this.multipleSelection.length != 1) return this.$message.warning('请选中一条数据')
			this.form = { ...this.form, ...this.multipleSelection[0] }
			let startUrl = 'http://localhost:8080'
			if(process.env.NODE_ENV == 'production'){
				startUrl = process.env.VUE_APP_BASE_URL
			}
			const res = await axios({
				baseURL: startUrl,
				timeout: 120000,
				headers: { 'x-auth-token': localStorage.getItem('x-auth-token'),'Content-Type': 'application/json' },			
					method: 'get',
					url: '/ffs/consignor/' + localStorage.getItem('tenantId') + '/invoice?wayBillNo=' + this.form.wayBillNo,         
					responseType: 'blob'
				  });
			if(!res.data) return;
			console.log(res.headers)
			const fileNameEncode = res.headers['content-disposition']
					.split('filename=')[1]
					.split(';')[0];
			console.log(fileNameEncode)
			const fileName = decodeURIComponent(fileNameEncode, 'utf-8').replace(/\+|\s/g, '');
			let url = window.URL.createObjectURL(new Blob([res.data]))
			let link = document.createElement('a')
			link.style.display = 'none'
			link.href = url
			link.setAttribute('download', fileName)         
			document.body.appendChild(link)
			link.click()	
		},
		// 回车
		keyupEnter(refname) {
			this.$nextTick(() => {
				this.$refs[refname].$children[1].blur()
				let index = this.$refs[refname].$parent.$children.indexOf(this.$refs[refname])
				let ref = this.$refs[refname].$parent.$children.find((item, i) => i > index && item.$options._componentTag == 'el-form-item' && !item.$children[1].disabled)
				if (ref) ref.$children[1].focus()
			})
		},
		// 最后回车
		onkeydown(refname, ref, ele) {
			this.$nextTick(() => {
				this.$refs[refname].$children[1].blur()
				if (ele) {
					this.$refs[ref].$el.focus()
				} else {
					this.$refs[ref].focus()
				}
			})
		},
	},
}
</script>

<style lang='scss' scoped>
.updatarow:focus {
	transform: scale(1.2);
}

.fulldia {
	.el-dialog__header {
		padding: 14px;
		height: 50px;
	}
	.el-dialog__body {
		padding: 14px;
		height: calc(100% - 50px);
	}
}
</style>
